import { z } from 'zod';

export const getModulesSchema = z.object({
  search: z.string().optional(),
  is_active: z
    .string()
    .optional()
    .transform((val) => (val === 'true' ? true : val === 'false' ? false : undefined))
    .pipe(z.boolean().optional()),
  limit: z
    .string()
    .optional()
    .default('10')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(1).max(100)),
  page: z
    .string()
    .optional()
    .default('0')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(0)),
});

export const getModuleSchema = z.object({
  module_id: z.uuid('Invalid module ID'),
});

export const deleteModuleSchema = z.object({
  module_id: z.uuid('Invalid module ID'),
});

export type GetModulesPayload = z.infer<typeof getModulesSchema>;
export type GetModulePayload = z.infer<typeof getModuleSchema>;
export type DeleteModulePayload = z.infer<typeof deleteModuleSchema>;
